import type * as core from '../../../../../core'

export const PACKAGE = {
  contents: [
    'package:data.higherEd.spaceWfuhs',
    'package:data.higherEd.research.idc.coreFunctions',
    'resource:data.dimensions.spaceFunctionalization.entities.entry.attributes.space',
    'resource:data.dimensions.spaceFunctionalization.entities.entry.attributes.spaceFunction',
    'resource:data.dimensions.spaceFunctionalization.entities.entry.attributes.weight',
    'resource:data.dimensions.spaceFunctionalization.entities.entry',
    'resource:data.dimensions.spaceFunctionalization',
    'resource:data.dimensions.spaceFunctions.entities.function.attributes.idcFunction',
    'resource:data.dimensions.spaceFunctions.entities.function.attributes.isExclusive',
    'resource:data.dimensions.spaceFunctions.entities.function.attributes.isSponsored',
    'resource:data.dimensions.spaceFunctions.entities.function',
    'resource:data.dimensions.spaceFunctions',
  ],
  description: 'TODO',
  name: 'Higher Ed Data - Space Usage',
} as const satisfies core.quiver.Package
